import {IAttributes, IDirective, IRootElementService, IScope} from "angular";

export const TouchEventFix = "touchEventFix";

export function touchEventFix(): IDirective {
    return {
        restrict: "A",
        link: ($scope: IScope, $elem: IRootElementService, $attr: IAttributes) => {
            $elem.on("touchend", (evt: JQueryEventObject) => {
                const source = evt.target;
                const click = new Event("click");
                source.dispatchEvent(click);
            });
        }
    };
}
